import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'extended, [glxyExtended]',
  standalone: false,
})
export class ExtendedDirective {
  @HostBinding('class') class = 'glxy-extended';
}
